import React from 'react'

function CloseIcon() {
  return (
    <svg
    className="w-7 h-7"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.842773"
      y="0.560791"
      width="51.1569"
      height="51.1569"
      rx="5"
      fill="#7030A0"
    />
    <path d="M26.4219 26.1392L18.8794 33.6816Z" fill="#6E6985" />
    <path
      d="M33.9643 33.6816L26.4219 26.1392M26.4219 26.1392L18.8794 18.5967M26.4219 26.1392L33.9643 18.5967M26.4219 26.1392L18.8794 33.6816"
      stroke="white"
      stroke-width="2.3"
      stroke-linecap="round"
    />
    <title>Close</title>
  </svg>
  )
}

export default CloseIcon